import React from "react";
import { CheckCircle, XCircle,X } from "lucide-react";

import WarningIcon from "../assets/images/WarningAmber.svg";

const QuizIncompleteWarning = ({ unanswered=0, onContinue, show,onClose,onExit }) => {
  if (!show) return null;



  return (
    <div
      className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
      style={{
        backgroundColor: "rgba(0,0,0,0.5)",
        backdropFilter: "blur(4px)",
        zIndex: 1100,
      }}
    >
      <style>{`
        .assessment-result-continue-btn { transition: filter 0.2s; }
        .assessment-result-continue-btn:hover { filter: brightness(0.9); }
      `}</style>
      <div
        className="bg-white rounded-3 shadow-lg overflow-hidden"
        style={{ width: "100%", maxWidth: "420px", margin: "0 16px" }}
      >
        {/* Header */}
        <div className="d-flex justify-content-between align-items-center gap-2 border-bottom  ">
        <div className="border-bottom px-4 py-3">
            <div className="d-flex align-items-center justify-content-center gap-2">

            <img src={WarningIcon} className="" alt="" style={{ width: "24px", height: "24px" }} />
          <h6 className="fw-bold text-center mb-0 text-danger">
            
            Wait Are You Sure?</h6>
            </div>
        </div>
        {onClose && (
            <button
              onClick={onClose}
              className="btn btn-link text-muted pl-2 border-0"
              style={{ lineHeight: 1,marginTop:'-3px' }}
            >
              <X size={20} />
            </button>
          )}
          </div>

        {/* Body */}
        <div className="text-center px-4 py-5">
          {/* Score Circle */}
         

          {/* Score Text */}
          <p className=" mb-2 text-muted">
            You have <span className="fw-semibold fs-6 text-dark">{unanswered} unanswered questions </span>
          </p>
          <p className="text-muted text-center" style={{ fontSize: "13px" }}>
            You Cannot Retake The Test.
          </p>
        </div>

        {/* Footer */}
        <div
          className="border-top px-4 py-3 d-flex justify-content-between"
          style={{ backgroundColor: "#F3F5F9" }}
        >
          <button
                    className="white"
            onClick={onExit}
            // style={{
            //   backgroundColor: "#081DA5",
            //   borderColor: "#081DA5",
            //   color: "#fff",
            //   fontWeight: 600,
            //   padding: "0.375rem 1.5rem",
            //   borderRadius: "8px",
            //   boxShadow: "0 1px 2px rgba(16, 24, 40, 0.05)",
            // }}
          >
            Exit
          </button>
          <button
                    className="white"
            onClick={onClose}
            style={{
              backgroundColor: "#081DA5",
              borderColor: "#081DA5",
              color: "#fff",
              fontWeight: 600,
              padding: "0.375rem 1.5rem",
              borderRadius: "8px",
              boxShadow: "0 1px 2px rgba(16, 24, 40, 0.05)",
            }}
          >
            Back to Quiz
          </button>
        </div>
      </div>
    </div>
  );
};

export default QuizIncompleteWarning;